import APIKit from "../Allapis/Apikit/apikit";
import { getUserList } from "./usersApis";
import { getFstUsersList } from "./fstUsersApi";

export const getFstUsers = async (params = {}) => {
  return getFstUsersList(params);
};

export const getUsersByRole = async (role, extra = {}) => {
  try {
    const params = { role, ...extra };
    const res = await getUserList(params);
    return res;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const assignFstUser = async (body) => {
  try {
    const res = await APIKit.post("/admin/fst/assign", body);
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const getFstAssignments = async (params = {}) => {
  try {
    const res = await APIKit.get("/admin/fst/assignments", { params });
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const getFstAssignmentLogs = async (params = {}) => {
  try {
    const { fstUserId, assignmentId, limit = 100 } = params;
    const res = await APIKit.get("/admin/fst/assignments/logs", {
      params: { fstUserId, assignmentId, limit },
    });
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const inactivateFstAssignment = async (assignmentId) => {
  try {
    const res = await APIKit.put(
      `/admin/fst/assignments/${assignmentId}/inactive`
    );
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};
